<form [formGroup]="form" *ngIf="form">
  <div>
    <span class="small weight-medium">
      {{ "sharedFeatures.PricingMethod" | translate }}
    </span>
  </div>
  <mat-radio-group formControlName="pricingMethod" #tooltip="matTooltip"
        [matTooltip]="'sharedFeatures.CustomerPartOfOrganization' | translate"
        matTooltipPosition="right" [matTooltipDisabled]="!isCustomerInheritFromOrg" (change)="onPricingMethodChanges($event)">
    <mat-radio-button color="primary" [value]="pricingMethod.PerTradeLane"></mat-radio-button>
    <mat-label class="text-700 small">{{ "sharedFeatures.PER_TRADE_LANE" | translate }}</mat-label>
    <mat-radio-button color="primary" [value]="pricingMethod.PerUnit"></mat-radio-button>
    <mat-label class="text-700 small">{{ "sharedFeatures.PER_UNIT" | translate }}</mat-label>
  </mat-radio-group>
  <mat-error class="small" *ngIf="form.get('pricingMethod').invalid && form.get('pricingMethod').touched">{{"ErrorMessages.Required" | translate}}</mat-error>
  
  <app-row *ngIf="form?.value?.pricingMethod === pricingMethod.PerUnit">
    <mat-label class="asterisk-after d-block small text-400">{{ "sharedFeatures.SelectUnitType" | translate }}</mat-label>
    <app-col class="flex col-sm-3" cols="12">
      <mat-form-field appearance="outline">
        <mat-select formControlName="units" appearance="outline">
          <mat-option *ngFor="let unit of unitsType | enumToArray" [value]="unit.value">
            {{ "sharedFeatures." + unit.value | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-col>
  </app-row>
</form>